import { render, staticRenderFns } from "./formContribuyente.vue?vue&type=template&id=400c9ec7&"
import script from "./formContribuyente.vue?vue&type=script&lang=js&"
export * from "./formContribuyente.vue?vue&type=script&lang=js&"
import style0 from "./formContribuyente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports